<template>
    <div class="auction-detail-info">
        <div
            class="auction-detail-info__header"
            :style="{
                'grid-template-columns':
                    'repeat(' +
                    (auction.status === AuctionStatus.InProgress ? (isAdmin() || auction.is_user_lot ? 4 : 5) : 3) +
                    ', 1fr)',
            }"
        >
            <div class="auction-detail-info__header-block">
                <div class="auction-detail-info__header-label">Дата начала</div>
                <div class="auction-detail-info__header-value">
                    {{ formatFromUTC(auction.start_date) }}
                </div>
            </div>

            <div class="auction-detail-info__header-block">
                <div class="auction-detail-info__header-label">Дата окончания</div>
                <div class="auction-detail-info__header-value">
                    {{ formatFromUTC(auction.end_date) }}
                </div>
            </div>

            <div class="auction-detail-info__header-block">
                <div class="auction-detail-info__header-label">Стартовая цена</div>
                <div class="auction-detail-info__header-value">{{ numberFormat(auction.start_price) }} ₽</div>
            </div>

            <div
                v-if="auction.status === AuctionStatus.InProgress && !auction.is_user_lot && !isAdmin()"
                class="auction-detail-info__header-block"
            >
                <div class="auction-detail-info__header-label">Всего ставок</div>
                <div class="auction-detail-info__header-value">
                    {{ auction.broadcastInfo?.bids_count ?? auction.bids_count }}
                </div>
            </div>

            <div
                v-if="auction.status === AuctionStatus.InProgress && auction.broadcastInfo"
                class="auction-detail-info__header-block auction-detail-info__header-block-timer"
            >
                <ViewAuctionTimer :second-to-end="auction.broadcastInfo.seconds_to_end" />
            </div>
        </div>

        <ViewAuctionInfoInProgress
            v-if="auction.status === AuctionStatus.InProgress && (isAdmin() || auction.is_user_lot)"
            :auction="auction"
        />

        <ViewAuctionInfoResults
            v-if="auction.status === AuctionStatus.AwaitingResult || auction.status === AuctionStatus.Completed"
            :auction="auction"
            @confirmed-winner="emit('confirmed-winner')"
        />
    </div>
</template>

<script setup lang="ts">
    import { defineEmits, PropType } from 'vue';

    import { Auction, AuctionStatus } from '@/types/auction.type.ts';

    import usePermission from '@/repositories/auth/usePermission.ts';

    import { formatFromUTC } from '@/utils/DateTimeFormatter.ts';
    import { numberFormat } from '@/utils/NumberFormatter.ts';

    import ViewAuctionInfoInProgress from '@/views/auctions/ViewAuction/components/ViewAuctionInfoInProgress/ViewAuctionInfoInProgress.vue';
    import ViewAuctionInfoResults from '@/views/auctions/ViewAuction/components/ViewAuctionInfoResults/ViewAuctionInfoResults.vue';
    import ViewAuctionTimer from '@/views/auctions/ViewAuction/components/ViewAuctionTimer/ViewAuctionTimer.vue';

    const { auction } = defineProps({
        auction: {
            type: Object as PropType<Auction>,
            required: true,
        },
    });

    const emit = defineEmits<{
        (e: 'confirmed-winner'): void,
    }>();

    const { isAdmin } = usePermission();
</script>

<style scoped lang="scss">
    @use 'ViewAuctionInfo.scss';
</style>
